<template>
    <div>
      <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
      <v-main class="main">
        <div class="pa-5 pt-7" style="display:flex;justify-content:center">
            <v-card style="width: 80%;height: 90%;min-height: 686px;border-radius: 20px !important;" v-if="!belink">
                <v-card-title class="pa-3 pb-1" style="border-bottom: solid #cecece;padding-left: 75px !important">
                    <v-img
                    contain
                    max-height="108"
                    max-width="100"
                    class="mr-5"
                    src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FMascot-Betask.png?alt=media&token=e7dcc64d-0d70-4179-9370-900348cd8ee5"
                    ></v-img>
                    ลงทะเบียน Belinked
                </v-card-title>
                <v-card-text class="pa-5">
                    <v-form ref="form_add" v-model="validAdd" lazy-validation>
                        <v-row justify="center" no-gutters style="height: 70px" class="mb-9">
                            <v-col cols="10" >
                                กรุณากรอกข้อมูลให้ครบถ้วน
                                <v-text-field
                                v-model="form.nameCompany"
                                label="ชื่อบริษัท"
                                class="mt-4 mb-5"
                                :rules="[rules.required]"
                                outlined
                                dense
                                />
                            </v-col>
                            </v-row>
                            <v-row justify="center" no-gutters class="mb">
                                <v-col cols="10">
                                    <v-select
                                    v-model="form.category"
                                    :items="category"
                                    label="ประเภทธุรกิจ"
                                    outlined
                                    required
                                    dense
                                    :rules="[rules.required]"
                                    @change="selectCategorySub(),form.category === 7 ? (selected = ['ซ่อมทั่วไป']): (selected = ['บริการเริ่มต้น'])"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row justify="center" no-gutters class="mt-0" v-if="categorySub.length > 0">
                                <v-col cols="10">
                                    <v-select
                                    v-model="form.categorySub"
                                    :items="categorySub"
                                    label="ประเภทบริการ"
                                    outlined
                                    required
                                    multiple
                                    attach
                                    dense
                                    chips
                                    :menu-props="{ bottom: true, offsetY: true }"
                                    :rules="[rules.required]"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <div v-show="vShow !== false">
                                <v-row justify="center" no-gutters v-if="form.category !== ''">
                                    <v-col cols="10" class="font18 ml-15">ประเภทบริการ</v-col>
                                    <v-col cols="9">
                                        <v-checkbox
                                        v-if="form.category === 7"
                                        v-model="selected"
                                        label="ซ่อมทั่วไป"
                                        value="ซ่อมทั่วไป"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols="9">
                                        <v-checkbox
                                        v-if="form.category === 7"
                                        v-model="selected"
                                        label="ซ่อมสีและตัวถัง"
                                        value="ซ่อมสีและตัวถัง"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols="9">
                                        <v-checkbox
                                        v-if="form.category === 7"
                                        v-model="selected"
                                        label="ล้าง ขัด เคลือบเงา"
                                        value="ล้าง ขัด เคลือบเงา"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols="9">
                                        <v-checkbox
                                        v-if="form.category !== 7"
                                        v-model="selected"
                                        label="บริการเริ่มต้น"
                                        value="บริการเริ่มต้น"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </div>
                            <v-row justify="center" no-gutters style="height: 70px">
                                <v-col cols="10">
                                    <v-text-field
                                    v-model="form.email"
                                    label="อีเมล"
                                    :rules="[rules.required, rules.email]"
                                    outlined
                                    dense
                                    />
                                </v-col>
                            </v-row>
                            <v-row justify="center" no-gutters class="mt-0">
                            <v-col cols="10">
                                <!-- <v-text-field
                                v-model="form.tel"
                                label="เบอร์ติดต่อ"
                                maxlength="10"
                                outlined
                                :rules="[rules.counterTel, rules.numberRules]"
                                /> -->
                                <v-text-field
                                v-model="form.tel"
                                label="เบอร์ติดต่อ"
                                outlined
                                required
                                dense
                                maxlength="10"
                                :rules="[rules.counterTel, rules.numberRules]">
                                </v-text-field>
                            </v-col>
                            <v-col cols="10">
                                <v-menu
                                ref="menu1"
                                v-model="menu1"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                    v-model="form.bdDate"
                                    outlined
                                    label="วันเกิด"
                                    v-bind="attrs"
                                    readonly
                                    :rules="[rules.required]"
                                    hide-details
                                    required
                                    dense
                                    v-on="on"
                                    append-icon="mdi-calendar"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    ref="picker1"
                                    v-model="form.bdDate"
                                    :active-date.sync="activePicker"
                                    :max="new Date().toISOString().substr(0, 10)"
                                    min="1950-01-01"
                                    locale="th-th"
                                    @change="save1"
                                ></v-date-picker>
                                </v-menu>
                            </v-col>
                            </v-row>
                            <v-row justify="center" no-gutter>
                            <v-col cols="10">
                                <v-btn
                                color="#001D6E"
                                style="font-size: 20px;color:white"
                                block
                                :disabled="!validAdd "
                                @click="addData()"
                                >
                                ยืนยันการลงทะเบียน
                                </v-btn>
                            </v-col>
                            </v-row>
                        <!-- <v-row justify="center" no-gutters style="height: 70px">
                            <v-col cols="8">
                                กรุณากรอกข้อมูลให้ครบถ้วน
                                <v-text-field
                                class="mt-4"
                                v-model="form.nameCompany"
                                label="ชื่อบริษัท"
                                :rules="[rules.required]"
                                outlined
                                dense
                                />
                            </v-col>
                        </v-row>
                        <v-row justify="center" no-gutters style="height: 70px">
                            <v-col cols="8">
                                <v-text-field
                                label="ชื่อบริษัท"
                                :rules="[rules.required]"
                                outlined
                                dense
                                />
                            </v-col>
                        </v-row> -->
                    </v-form>
                </v-card-text>
            </v-card>
        </div>
      </v-main>
    </div>
  </template>
<script>
import axios from 'axios' // api
// import moment from 'moment-timezone'
// import PrivacyNotice from '../Welcome/PrivacyNotice.vue'
// import NavbarRegister from '../Welcome/NavbarRegister.vue'
import VueRecaptcha from 'vue-recaptcha'
export default {
  components: {
    name: '',
    // PrivacyNotice,
    // NavbarRegister,
    'vue-recaptcha': VueRecaptcha
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
    }
  },
  watch: {
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker1.activePicker = 'YEAR'))
    }
  },
  data () {
    return {
      menu1: false,
      activePicker: null,
      vShow: false,
      dialogPrivacyNotice: false,
      overlay: false,
      recapStatus: false,
      checkTerm1: false,
      checkTerm2: false,
      form: {
        nameCompany: this.$session.getAll().data.name,
        email: this.$session.getAll().data.userEmail,
        tel: this.$session.getAll().data.contactTel.replace(/-/g, ''),
        category: '',
        categorySub: [],
        bdDate: ''
      },
      selected: ['ซ่อมทั่วไป'],
      // category: [
      //   { text: 'ธุรกิจเสริมสวย', value: 'ธุรกิจเสริมสวย' },
      //   { text: 'ธุรกิจคลินิก', value: 'ธุรกิจคลินิก' },
      //   { text: 'ธุรกิจโรงพยาบาล', value: 'ธุรกิจโรงพยาบาล' },
      //   { text: 'ธุรกิจสนามกีฬา', value: 'ธุรกิจสนามกีฬา' },
      //   { text: 'ศูนย์การเรียนรู้', value: 'ศูนย์การเรียนรู้' },
      //   { text: 'หน่วยงานราชการ', value: 'หน่วยงานราชการ' },
      //   { text: 'ธุรกิจรถยนต์', value: 'ธุรกิจรถยนต์' },
      //   { text: 'ธุรกิจอื่นๆ', value: 'ธุรกิจอื่นๆ' }
      // ],
      category: [],
      Allcategory: [],
      categorySub: [],
      AllcategorySub: [],
      counterTel: [
        v => !!v || 'กรุณากรอก',
        v => (v && v.length < 13) || 'กรุณากรอกเบอร์ให้ครบ'
      ],
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
            'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length <= 10 || 'กรุณากรอกเบอร์ให้ครบ',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
            'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอก.',
        resizeImag: (value) =>
          !value ||
            value.size < 2000000 ||
            'Avatar size should be less than 2 MB!',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      recapchaToken: '',
      shopIdGoto: '',
      shopId: '',
      dataReady: true,
      belink: true,
      validAdd: true,
      dialog: false,
      dialogEnd: false,
      widthScreen: window.screen.width,
      privacyConfigDetail:
          '<h6 class="ql-align-center">เรื่อง นโยบายความเป็นส่วนตัว</h6><p class="ql-align-center"><br></p><p class="ql-align-center">บริษัท บีแทสก์ คอนซัลติ้ง จำกัด เห็นความสำคัญ ในการปกป้องข้อมูลส่วนบุคคล  เพื่อเป็นให้เป็นไปตาม<a href="http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0052.PDF" rel="noopener noreferrer" target="_blank" style="color: rgb(0, 123, 255);">พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562</a></p><hr class="ql-align-center"><p class="ql-align-center">ผู้ให้บริการให้มี สิทธิการเข้าถึงข้อมูล <code style="color: rgb(232, 62, 140);">(Personal Data Protection Act : PDPA)</code></p><hr><p><strong><u>สำคัญ</u></strong></p><ol><li>ในการใช้บริการนี้ ผู้ใช้ต้องตรวจสอบว่าได้ดำเนินการผ่าน V-LINK ผู้ให้บริการนี้ไม่ ต้องรับผิดชอบต่อความเสียหายใดๆ ที่เกิดจากการใช้บริการจาก แหล่งอื่นที่ไม่ใช่ผู้ให้บริการอย่างเป็นทางการ</li><li>ข้อมูลส่วนบุคคลที่มอบให้แก่บริการนี้และข้อมูลส่วนบุคคลที่ รวบรวมใหม่จะถูกนำไปใช้ภายใต้ความรับผิดชอบของผู้ใช้บริการ นี้ โปรดตรวจสอบรายละเอียดในข้อกำหนดการใช้บริการและ นโยบายความเป็นส่วนตัวของผู้ให้บริการ</li><li>ข้อมูลโปรไฟล์ประกอบด้วย ชื่อ-นามสกุล,วันเกิด ,อีเมลล์</li><li>โปรดตรวจสอบว่า ชื่อ-นามสกุลของท่าน ไม่มีเนื้อหาที่ละเมิดในสิทธิ์ของผู้ใด เช่น ละเมิดลิขสิทธิ์ ละเมิด ความเป็นส่วนตัว ตามที่ระบุในข้อกำหนดการใช้บริการ บริษัท บีแทสก์ คอนซัลติ้ง จำกัด</li></ol><p><br></p>'
    }
  },
  created () {
    window.addEventListener('resize', this.myEventHandler)
  },
  destroyed () {
    window.removeEventListener('resize', this.myEventHandler)
  },
  async mounted () {
    // console.log(this.$session.getAll().data.contactTel.split('-').join())
    await this.getCategory()
    await this.getCategorySub()

    axios
      .get(this.DNS_IPBelink + '/sys_shop/get?shopId=' + this.$session.getAll().data.shopId)
      .then(res => {
        // console.log('test', res.data[0].shopStatus)
        if (Array.isArray(res.data)) {
          this.belink = true
        } else {
          this.belink = false
        }
      })
    // this.$ga.enable()
    // if (this.$route.query.state === 'register' && this.$route.query.productName === 'link') {
    //   await this.getBotLineIdLink()
    //   // await this.getOaLink()
    // } else {
    //   this.$swal('ผิดพลาด', 'กรุณาติดต่อเจ้าหน้าที่', 'error')
    // }
    // this.dialog = true
    // this.validate('ADD')
    // this.getTest()
  },
  methods: {
    save1 (date) {
      console.log('dddd', date)
      this.$refs.menu1.save(date)
    },
    myEventHandler (e) {
      this.getSceenSize()
    },
    getSceenSize () {
      this.widthScreen = window.innerWidth
      // console.log('ssssss', this.widthScreen)
    },
    async getCategory () {
      await axios.get(this.DNS_IPBelink + '/category/getsort')
        .then(async (response) => {
          let rs = response.data
          console.log('rs_getCategory', rs)
          if (rs.length > 0) {
            this.Allcategory = rs
            rs.forEach((d) => {
              let s = {}
              s.text = d.nameCategoryTH
              s.textEn = d.nameCategoryEN
              s.value = d.idCategory
              // s.value = d.nameCategoryTH
              this.category.push(s)
            })
          }
        }).catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    async getCategorySub () {
      await axios.get(this.DNS_IPBelink + '/categorySub/getsort')
        .then(async (response) => {
          let rs = response.data
          console.log('rs_getCategorySub', rs)
          if (rs.length > 0) {
            this.AllcategorySub = rs
          }
        }).catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    async selectCategorySub () {
      this.form.categorySub = []
      this.categorySub = []
      console.log('this.form', this.form.category)
      // let Id = this.Allcategory.filter((i) => i.nameCategoryTH === this.form.category)[0].idCategory
      // console.log('ddfdfsdfsdf', this.Allcategory.filter((i) => i.nameCategorySubTH === this.form.category))
      this.AllcategorySub.forEach((d) => {
        let s = {}
        if (d.idCategory === this.form.category) {
          s.text = d.nameCategorySubTH
          s.textEn = d.nameCategorySubEN
          s.value = d.idCategorySub
          this.categorySub.push(s)
        }
      })
      console.log('this.cat', this.categorySub)
    },
    closeDialogPDPA () {
      console.log('closeDialogPDPA', this.recapStatus, this.checkTerm1, this.checkTerm2)
      if (this.checkTerm1 === true && this.checkTerm2 === true) {
        this.dialogPrivacyNotice = false
        console.log('gtmTrackEvent')
        this.gtmTrackEvent('PDPA', 'click', 'Agree PDPA')
      }
    },
    closeDialog () {
      this.dialog = false
      this.gtmTrackEvent('PDPA', 'click', 'Agree PDPA')
    },
    gtmTrackEvent (category, action, label) {
      try {
        if (this.$gtm.enabled()) {
          console.log('enable')
        } else {
          console.log('disable')
        }
        this.$gtm.trackEvent({
          category: category,
          action: action,
          label: label
        })
      } catch (err) {
        console.log(err)
      }
    },
    gotoLogin () {
      window.location.href = 'https://betask-linked-admin.web.app/'
      // this.$router.push('/RegisterClose')
    },
    gotoClose () {
      window.location.href = 'https://betaskthai.com/be_linked/'
      // this.$router.push('/RegisterClose')
    },
    validate () {
      this.$refs.form_add.validate()
    },
    linkTo (Linkitem) {
      window.open(Linkitem, '_blank')
      // window.location.href = 'http://stackoverflow.com'
    },
    openPrivacyNotice (check) {
      if (check === 1) {
        window.open('https://betaskthai.com/privacy-policy-customer/')
      } else {
        window.open('https://betaskthai.com/privacy-policy-services/')
      }
    },
    // validate (Action) {
    //   switch (Action) {
    //     case 'ADD':
    //       this.$nextTick(() => {
    //         let self = this
    //         self.$refs.form_add.validate()
    //       })
    //       break
    //     case 'UPDATE':
    //       this.$nextTick(() => {
    //         let self = this
    //         self.$refs.form_update.validate()
    //       })
    //       break

    //     default:
    //       break
    //   }
    // },
    // async getBotLineIdLink () {
    //   let dt = {
    //     code: this.$route.query.code,
    //     redirect_uri: 'https://betask-linked.web.app/register?productName=' + this.$route.query.productName
    //   }
    //   await axios
    //     .post(
    //       // eslint-disable-next-line quotes
    //       this.DNS_IP + "/line/linkYourBot",
    //       dt
    //     )
    //     .then(async (response) => {
    //       console.log('getBotLineId', response.data)
    //       // this.form.shopId = response.data.bot_id
    //       await axios
    //         .get(this.DNS_IP + '/sys_shop/get?shopId=' + response.data.bot_id)
    //         .then(async (responses) => {
    //           console.log('sys_shop', responses.data)
    //           if (responses.data.status === false) {
    //             this.dialog = true
    //             this.validate('ADD')
    //             this.shopId = response.data.bot_id
    //           } else {
    //             this.dialog = false
    //             this.$swal('ผิดพลาด', 'Line OA ของท่านได้เข้าร่วม Be-Link กรุณา Log In', 'error')
    //             this.$router.push('/registerClose')
    //             // location.replace('https://betask-linked.web.app/registerClose')
    //           }
    //         })
    //       // await this.getOaLink(response.data.bot_id)
    //       // location.replace('https://betask-linked-admin.web.app')
    //     })
    //     // eslint-disable-next-line handle-callback-err
    //     .catch((error) => {
    //       console.log(error)
    //       // this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
    //       this.dataReady = true
    //     })
    // },
    verifyMethod (a) {
      this.recapchaToken = a
      this.recapStatus = false
      this.closeDialogPDPA()
      this.$refs.form_add.validate()
    },
    renderMethod (c) {
      console.log(c)
    },
    checkboot () {
      if (this.$route.query.ref === 'boot') {
        window.location = 'https://betask-linked-admin.web.app/'
      } else {
        this.$router.push('/CreateLineOAaccount?shopId=' + this.shopIdGoto)
      }
    },
    addData (d) {
      console.log('token', d)
      console.log('formAdd', this.form)
      this.validate()
      setTimeout(() => this.addDataSubmit(), 500)
    },
    async addDataSubmit () {
      console.log('ddd')
      if (this.validAdd !== false) {
        if (this.form.tel.length >= 10) {
          this.overlay = true
          if (this.selected.length > 0) {
            axios
              .get(this.DNS_IPBelink + '/system_user/get?userName=' + this.form.email)
              .then((response1) => {
                if (response1.data.status === false) {
                  this.$swal({
                    title: 'ต้องการ ลงทะเบียน ใช่หรือไม่?',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#b3b1ab',
                    confirmButtonText: 'ใช่',
                    cancelButtonText: 'ไม่'
                  })
                    .then(async (result) => {
                      var sourceLink = ''
                      if (this.$route.query.ref !== undefined) {
                        sourceLink = this.$route.query.ref
                      } else {
                        sourceLink = ''
                      }
                      // var shopId = moment().valueOf()
                      var data = {
                        shopId: this.$session.getAll().data.shopId,
                        arrayTypeService: this.selected,
                        shopName: this.form.nameCompany,
                        category: this.form.category,
                        categorySub: JSON.stringify(this.form.categorySub),
                        contactEmail: this.form.email,
                        contactTel: this.form.tel,
                        birthday: this.form.bdDate,
                        sourceLink: sourceLink
                      }
                      await axios
                        .post(this.DNS_IPBelink + '/register/add', data)
                        .then(async (response) => {
                          // Debug response
                          let rs = response.data
                          if (rs.status) {
                            // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                            await axios
                              .get(
                                // eslint-disable-next-line quotes
                                this.DNS_IPBelink +
                                    '/system_user/get?userName=' +
                                    this.form.email
                              )
                              .then(async (response) => {
                                if (response.data[0]) {
                                  this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                                  window.location.href = `https://betask-linked-admin.web.app/Core/Login`
                                } else {
                                  this.overlay = false
                                  this.$swal(
                                    'ผิดพลาด',
                                    'Account ไม่ถูกต้อง1',
                                    'error'
                                  )
                                }
                              })
                            // eslint-disable-next-line handle-callback-err
                              .catch((error) => {
                                this.overlay = false
                                console.log(error)
                                this.$swal(
                                  'ผิดพลาด',
                                  'Account ไม่ถูกต้อง2',
                                  'error'
                                )
                              })
                          } else {
                            this.overlay = false
                            this.$swal(
                              'ผิดพลาด',
                              'กรุณากรอกข้อมูลใหม่อีกครั้งคะ',
                              'error'
                            )
                          }
                        })
                      // eslint-disable-next-line handle-callback-err
                        .catch((error) => {
                          console.log('error function addDataGlobal : ', error)
                          // this.$router.push(
                          //   '/system/Errorpage?returnLink=' + this.returnLink
                          // )
                          this.overlay = false
                        })
                    })
                    .catch((error) => {
                      console.log('error function addData : ', error)
                      this.overlay = false
                    })
                } else {
                  this.$swal(
                    'ผิดพลาด',
                    'อีเมลของท่าน มีอยู่ในระบบแล้ว กรุณากรอกอีเมลใหม่',
                    'error'
                  )
                  this.overlay = false
                }
              })
          } else {
            this.$swal('ผิดพลาด', 'กรุณาเลือก ประเภทบริการ', 'error')
            this.overlay = false
          }
        } else {
          this.$swal(
            'ผิดพลาด',
            'กรุณากรอกเบอร์โทรให้ครบ 10 หลัก',
            'error'
          )
        }
      }
    }
  }
}
</script>
  <style scoped>
  .bgPage {
    background: linear-gradient(180deg, #ffffff 10%, #e1f3ff 100%);
    position: absolute;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
  }
  hr {
    border: none;
    border-top: 4px dotted grey;
    color: #fff;
    background-color: #fff;
    height: 1px;
    width: 50%;
    margin-top: 30px;
  }
  .main {
  padding: 0px;
  background: #ffffff;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(180deg, #ffffff 10%, #e1f3ff 100%);
}
  </style>



// WEBPACK FOOTER //
// src/components/Core/Belink.vue